import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initializePOProductForm, loadPOProductItem, clearFormInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import util from 'library/util';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import RadioInput from 'screens/components/basic/RadioInput';
import { selectAuditProductModel } from 'selectors/entitySelector';

class AuditProductSave extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: []
        }
        this.list = [];
    }

    componentWillMount() {
        this.props.init(this.props.name);
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.productListLength !== this.props.productListLength && newProps.productListLength != null && newProps.productListLength != undefined) || this.props.products && this.props.products != newProps.products) {
            let arrayOfProduct = newProps.products.filter(c => c.status === "Active");
            let slectionList = [];
            if (newProps.searchMethod === "sku") {
                slectionList = this.loadSKUList(arrayOfProduct);
            }
            else {
                slectionList = this.loadList(arrayOfProduct);
            }
            this.setState({
                productList: slectionList
            });
        }

        if (newProps.selectedProduct) {
            if (this.props.selectedProduct !== newProps.selectedProduct) {
                console.log(this.props.name, newProps.selectedProduct, this.props.products)
                this.props.loadForm(this.props.name, newProps.selectedProduct, this.props.products);
            }
        }

        if (this.props.searchMethod != newProps.searchMethod && newProps.searchMethod != null && newProps.searchMethod != undefined) {
            let activeProducts = this.props.products ? this.props.products.filter(p => p.status === "Active") : [];
            let slectionList = [];
            if (newProps.searchMethod === "sku") {
                slectionList = this.loadSKUList(activeProducts);
            }
            else {
                slectionList = this.loadList(activeProducts);
            }
            this.setState({
                productList: slectionList
            });
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput('InventoryAuditSearchMethod');
    }

    addProduct = () => {
        const p = this.props;
        const validators = [
            [p.name + 'Id', product => (product.id !== 0), "Product"],
            [p.name + 'Sku', product => (product.sku !== ""), "Product"],
            [p.name + 'Name', product => (product.name != ""), "Product"],
        ];

        let product = this.props.productModel;

        if (util.validate(validators, product, this.props.formError)) {
            this.props.addProduct(product);
            this.clearForm();
        }
        else {
            this.props.showError("Invalid product parameters");
        }
    }

    clearForm = () => {
        this.props.clearFormInput(`${this.props.name}Name`);
        this.props.clearFormInput(`${this.props.name}Sku`);
    }

    loadList = (products = []) => {
        this.list = [];
        products.map((product) => {
            this.list.push(
                { text: product.name, value: parseInt(product.id), id: parseInt(product.id) }
            );
        });
        return this.list;
    }

    loadSKUList = (products = []) => {
        this.list = [];
        products.map((product) => {
            this.list.push(
                { text: product.sku, value: parseInt(product.id), id: parseInt(product.id) }
            );
        });
        return this.list;
    }

    render() {

        let p = this.props;
        let activeProducts = this.state.productList;
        let searchMethods = [{
            text: "Name",
            value: "name"//1
        }, {
            text: "SKU",
            value: "sku"
        }]

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <RadioInput
                            title="Search Method"
                            groupName="InventoryAuditSearchMethod"
                            options={searchMethods}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <AutoCompleteInput
                            methodName="InventoryAuditSearchMethod"
                            name={`${p.name}Id`}
                            className="AutoCompleteInput-searchbar"
                            label={this.props.searchMethod == "sku" ? "Search an existing product by SKU" : "Search an existing product by Name"}
                            hintText="Product"
                            options={activeProducts} 
                            productType="audit"
                        />
                    </div>
                    <div className="col-xs-6">
                        {
                            this.props.searchMethod == "sku" ?
                                <TextInput
                                    name={`${p.name}Name`}
                                    fullWidth={true}
                                    label={LOOKUP.product.name.label}
                                    hintText={LOOKUP.product.name.label}
                                    floatingLabelText={LOOKUP.product.name.label}
                                    disabled={true} />
                                :
                                <TextInput
                                    name={`${p.name}Sku`}
                                    fullWidth={true}
                                    label={LOOKUP.product.sku.label}
                                    hintText={LOOKUP.product.sku.label}
                                    floatingLabelText={LOOKUP.product.sku.label}
                                    disabled={true} />
                        }
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-lg-12">
                        <Button
                            name="addButton"
                            className="pull-right"
                            label={LOOKUP.product.controls.addButton}
                            primary={true}
                            onTouchTap={this.addProduct}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        productModel: selectAuditProductModel(state, props.name),
        products: state.entity.auditProductList,
        selectedProduct: state.form[props.name + "Id"] ? parseInt(state.form[props.name + "Id"]) : '',
        branchId: state.common.branchId,
        productListLength: state.entity.auditProductListLength,
        searchMethod: state.form["InventoryAuditSearchMethod"]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (name) => dispatch(initializePOProductForm(name)),
        loadForm: (name, productId, products) => dispatch(loadPOProductItem(name, productId, products)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(AuditProductSave);
